import ReturnsNullOn404 from "common/http/returnsNullOn404";
import UserPreference from "features/userPreferences/userPreference";
import AdminHttpService from "./adminHttpService";

class UserPreferencesService extends AdminHttpService {

    @ReturnsNullOn404()
    async getPreferences(merchantId: string, ...keys: string[]): Promise<UserPreference[]> {
        var response = await this.getClient(merchantId).get<UserPreference[]>('/settings/v1/user-preferences', {
            params: { keys: keys?.join(',')}
        });
        return response.data;
    }

    async updatePreference(merchantId: string, key: string, value: string): Promise<any> {
        await this.getClient(merchantId).put(`/settings/v1/user-preferences/${key}`, { value: value });
    }

    async getAdminPreferences(...keys: string[]): Promise<UserPreference[]> {
        var response = await this.getClient().get<UserPreference[]>('/settings/v1/admin-user-preferences', {
            params: { keys: keys?.join(',')}
        });
        return response.data;
    }

    async updateAdminPreference(key: string, value: string): Promise<any> {
        await this.getClient().put(`/settings/v1/admin-user-preferences/${key}`, { value: value });
    }
}

const userPreferencesService = new UserPreferencesService();

export default userPreferencesService;